import type { ReactNode } from 'react'
import type { MenuProps } from 'antd'

export function orderBatchActionItems({
  contractLabel,
  contractDisabled,
  canContract,
  canManageContracts,
  canManage,
  isOwner
}: {
  contractLabel: ReactNode
  contractDisabled: boolean
  canContract: boolean
  canManageContracts: boolean
  canManage: boolean
  isOwner: boolean
}): MenuProps['items'] {
  return [
    ...(canContract ? [{ key: 'contract', label: contractLabel, disabled: contractDisabled }] : []),
    ...(canManageContracts ? [{ key: 'contractStatus', label: '修改合同状态' }] : []),
    ...(canManage
      ? [
          { key: 'salesperson', label: '批量修改业务员' },
          { key: 'customer', label: '批量修改客户' },
          { key: 'group', label: '批量纳入订单组' }
        ]
      : []),
    ...(canManage || isOwner ? [{ type: 'divider' as const }] : []),
    ...(canManage ? [{ key: 'delete', label: '批量删除', danger: true }] : []),
    ...(isOwner ? [{ key: 'forceDelete', label: '批量强制删除', danger: true }] : [])
  ]
}
